export const InspectionsTableFields = {
    VESSEL: "vesselName",
    ACTIONS: "actions",
    GRADE: "idwalGrade",
    STATUS: "inspectionStatus",
    STATUS_FRIENDLY_NAME: "inspectionStatusFriendlyName",
    GUID: "inspectionGuid",
    IMO: "imo",
    INSPECTION: "inspection",
    INSPECTION_TYPE: "inspectionType",
    INSPECTION_NUMBER: "inspectionNumber",
    INSPECTION_PORT: "port",
    INSPECTION_DATE_FROM: "inspectionDateFrom",
    INSPECTION_DATE_TO: "inspectionDateTo",
    INSPECTION_DATE: "inspectionDate",
    ISSUED_AT: "issuedAt",
    ISSUED_AT_SORT_FIELD: "issuedAtSortField",
    INSPECTION_DATE_SORT_FIELD: "inspectionDateSortField",
    VESSEL_TYPE: "vesselType",
    TOTAL_PRICE_SORT_FIELD: "totalPriceSortField",
    TOTAL_PRICE: "totalPrice",
    LOCATION: "location"
};

export const FilterOptionFields = {
    UNDER_SIX_MONTHS: "Under 6 months",
    BETWEEN_SIX_MONTHS_AND_ONE_YEAR: "Between 6 months and 1 year",
    BETWEEN_ONE_YEAR_AND_TWO_YEARS: "Between 1 years and 2 years",
    OVER_TWO_YEARS: "Over 2 years",
    GRADE_NINETY: "90+",
    GRADE_SEVENTY: "70-89",
    GRADE_FIFTY: "50-69",
    GRADE_THIRTY: "30-49",
    GRADE_ZERO: "0-29",
    UNDER_TWO_WEEKS: "Under 2 weeks",
    BETWEEN_TWO_WEEKS_AND_ONE_MONTH: "Between 2 weeks and 1 month",
    BETWEEN_ONE_MONTH_AND_TWO_MONTHS: "Between 1 month and 2 months",
    OVER_TWO_MONTHS: "Over 2 months"
};
